import { render, staticRenderFns } from "./AuthorStagePatchModeUpload.vue?vue&type=template&id=5bbd000a&"
import script from "./AuthorStagePatchModeUpload.vue?vue&type=script&lang=js&"
export * from "./AuthorStagePatchModeUpload.vue?vue&type=script&lang=js&"
import style0 from "./AuthorStagePatchModeUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports